<script setup>
    import { reactive, watch, computed } from 'vue'

    const emit = defineEmits(['executeMethod']);
    //親コンポーネントから受け継いだプラン情報
    const props = defineProps({
        PlanObject: {
            type: Object,
            require: true
        },
    });
    const reactiveObj = reactive({
        choiceNum: 0
    })
    //全ての入力フォームが入力されたときに変更ボタンを活性化させる
    const inputSomeData = () => {
        //変更ボタンの活性化フラグ
        let equalFlag = false
        //全ての入力フォームが入力されたときに変更ボタンの活性化フラグをTrueにする
        if(reactiveObj.choiceNum) {
            equalFlag = true
        }
        //活性判定フラグTrueなら変更ボタンを活性化そうでないなら非活性化
        equalFlag ? document.getElementById('commonButtonPlanChange').disabled = false: document.getElementById('commonButtonPlanChange').disabled = true
    }
    //リアクティブオブジェクトのリセット
    const valueReset = () => {
        reactiveObj.choiceNum = 0
    }
    //モーダルウィンドウが閉じるときに実行
    const exitModal = (editFlag) => {
        //親コンポーネントに編集の是非とその値を渡す
        emit('executeMethod', editFlag, { PlanValue: props.PlanObject.PlanValue + 1});
        //モーダルウィンドウを閉じる際に追加ボタンを非活性化
        document.getElementById('commonButtonPlanChange').disabled = true;
        valueReset()
    }
    //プラン変更時のCSSの適応
    const changePlan = (choiceNum) => {
        //選択したプランの番号を取得、格納
        reactiveObj.choiceNum = choiceNum
        //表示しているプランのDOMを取得
        const planItems = document.getElementsByClassName('planLabel')
        //表示しているプランの数だけ繰り返し
        for(let index = 0; index < planItems.length; index++) {
            //選択したプランの番号と一致していれば活性色に変更
            if(index == reactiveObj.choiceNum) {
                planItems[index].style.background = '#00AEEB';
            }
            //そうでなければ非活性色に変更
            else {
                planItems[index].style.background = '#d7d7d7';
            }
        }
    }
    //リアクティブオブジェクトの監視
    watch(reactiveObj, () => {
        inputSomeData()
    })
</script>

<template>
    <div class="modalArea">
        <div id="modalContent" class="modal" :style="{ height: `${props.PlanObject.NextPlanValue ? '600px' : '300px'}`}">
            <p class="modalTitle">プランの変更</p>
            <div class="modalInfo">
                <div class="PlanArea">
                    <p class="planDescription">現在のプラン</p>
                    <div class="planLabel">
                        <label class="planDetail">
                            <input type="radio" class="plan" name="plan" @change="changePlan(0)">
                            <div class="leftText">
                                <p class="planName">{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue]?.PlanName }}</p>
                                <p class="emphasis">利用者：最大 <span class="emphasisMessage">{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue]?.LimitUserCount }}</span>名</p>
                                <p class="emphasis">デバイス：最大 <span class="emphasisMessage">{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue]?.LimitTerminalCount }}</span>台</p>
                            </div>
                            <div class="rightText">
                                <p>【料金】</p>
                                <p>月払い：{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue]?.Price1.toLocaleString() }}円/年</p>
                                <p>年払い：{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue]?.Price12.toLocaleString() }}円/年</p>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="modalInfo"  v-show="props.PlanObject.NextPlanValue" >
                <div class="PlanArea">
                    <p class="planDescription">上位のプラン</p>
                    <div class="planLabel" style="background-color: #d7d7d7;">
                        <label class="planDetail">
                            <input type="radio" class="plan" name="plan" @change="changePlan(1)">
                            <div class="leftText">
                                <p class="planName">{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue + 1]?.PlanName }}</p>
                                <p class="emphasis">利用者：最大 <span class="emphasisMessage">{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue + 1]?.LimitUserCount }}</span>名</p>
                                <p class="emphasis">デバイス：最大 <span class="emphasisMessage">{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue + 1]?.LimitTerminalCount }}</span>台</p>
                            </div>
                            <div class="rightText">
                                <p>【料金】</p>
                                <p>月払い：{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue + 1]?.Price1.toLocaleString() }}円/年</p>
                                <p>年払い：{{ props.PlanObject.PlanInfo[props.PlanObject.PlanValue + 1]?.Price12.toLocaleString() }}円/年</p>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="modalInfo" v-show="false">
                <p>支払い方法</p>
                <input type="text" class="modalInput" id="payment">
            </div>
            <button type="button" id="commonButtonPlanChange" @click="exitModal(true)" v-show="props.PlanObject.NextPlanValue" disabled>変更する</button>
        </div>
        <div class="modalOverlay" @click.self="exitModal(false)"></div>
    </div>
</template>

<style scoped>
    .modal {
        height: 700px;
        width: 700px;
        top: 50%;
        left: 50%;
    }
    #commonButtonPlanChange {
        width: 190px;
        height: 70px;
        top: 30px;
        left: 50%;
    }
    .modalInfo {
        display: flex;
        flex-direction: row;
        padding: 0 3% 0 3%;
        .PlanArea {
            width: 100%;
            .planDescription {
                top: 0px;
            }
            .planLabel {
                background-color: #00AEEB;
                margin: 10px 0 10px 0;
                border-radius: 20px;
                width: 100%;
                .planDetail {
                    padding: 0 20px 10px 20px;
                    display: flex;
                    align-items: flex-end;
                    .plan {
                        display: none;
                    }
                    .leftText {
                        width: 50%;
                        .planName {
                            font-weight: bold;
                            font-size: 35px;
                            color: black;
                        }
                        .emphasis {
                            color: black;
                            .emphasisMessage {
                                line-height: 100%;
                                color: red;
                                font-size: 20px;
                                font-weight: bold;
                            }
                        }
                    }
                    .rightText {
                        width: 50%;
                        p {
                            color: black;
                        }
                    }
                }
            }
        }
        p {
            width: 100%;
        }
    }
    .modalInput {
        width: 500%;
    }
    @media (max-width: 1000px) {
        .modal {
            width: auto;
            height: auto;
            display: flex;
            justify-content: left;
            align-items: left;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .modalInfo {
            flex-direction: column;
            padding: 3% 0 3% 0;
            width: 100%;
            .PlanArea {
                .planLabel {
                    width: 300px;
                    .planDetail {
                        display: block;
                        align-items: initial;
                    }
                }
            }
            p {
            width: 200px;
        }
        }
        .modalInput {
            width: 100%;
        }
        #commonButtonPlanChange {
            margin: 20px 0 20px 0;
            top: 30px;
            height: auto;
        }
    }
</style>